import '../../assets/global.css'
import { useUser } from '../../context/userContext';
import { getAllSalesByAgentId } from '../../api/salesApi';
import SalesModal from './salesModal';
import { useNavigate } from 'react-router-dom';
import GenericSalesList from '../common/genericSalesList';

export default function SalesList() {
    const navigate = useNavigate();
    const { user } = useUser();

    const handleCreate = () => {
        navigate("/sales/create");
    };

    return (
        <GenericSalesList
            fetchDataApi={() => getAllSalesByAgentId(user?.userId)}
            ModalComponent={SalesModal}
            onCreate={handleCreate}
        />
    )
}